export default __webpack_public_path__ + "static/media/AGC_2023_R2_QP_Class_3.d3aa4818.pdf";